import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/**
 * SubPageShell — shared layout for the rider menu sub-pages
 * (Saved Places, Payment Methods, Help, Notifications, etc.).
 *
 * Provides a consistent header with a Back chip, an orange micro-eyebrow,
 * a serif title, and a content slot. Cream `#F9F7F4` background so all
 * the menu surfaces feel like one product zone.
 */
export default function SubPageShell({
  eyebrow,
  title,
  subtitle,
  testId,
  back = "/",
  backLabel = "Back",
  children,
}) {
  const nav = useNavigate();
  return (
    <div
      className="fixed inset-0 flex flex-col bg-[#F9F7F4]"
      data-testid={testId}
    >
      <div className="flex-1 min-h-0 overflow-y-auto wheel-scroll">
        <div
          className="max-w-2xl mx-auto px-4 sm:px-6 pb-[max(env(safe-area-inset-bottom),96px)]"
          style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 80px)" }}
        >
          <button
            type="button"
            onClick={() => nav(back)}
            className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.22em] uppercase font-semibold text-[#515E7B] hover:text-[#ed6500] transition-colors mb-4"
            data-testid={`${testId}-back`}
          >
            <ChevronLeft size={14} strokeWidth={2} />
            <span>{backLabel}</span>
          </button>
          {eyebrow && (
            <div className="text-[10px] tracking-[0.24em] uppercase font-semibold text-[#ed6500] mb-2">
              {eyebrow}
            </div>
          )}
          <h1 className="font-serif font-light text-3xl sm:text-4xl leading-tight text-[#0A1128]">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-[#515E7B] mt-2 max-w-prose">{subtitle}</p>
          )}
          <div className="mt-7">{children}</div>
        </div>
      </div>
    </div>
  );
}
